import { createContext, useContext } from 'react';

export interface AccountSession {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  uid: string;
  email: string | null;
  role: 'admin' | 'operator' | 'viewer';
  deviceId: string;
}

export interface AuthContextValue {
  status: 'loading' | 'anonymous' | 'authenticated';
  session: AccountSession | null;
  signIn: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error('useAuth must be used inside AuthProvider');
  return value;
}
